<template>
  <div class="range-filter" v-bind="config.attrs">

    <!-- ===== ACCORDION MODE (CTC only, config-driven) ===== -->
    <template v-if="isAccordion">
      <div
        class="filter-accordion__header"
        role="button"
        tabindex="0"
        @click="toggle"
        @keyup.enter="toggle"
        @keydown.space.prevent="toggle"
      >
        <span class="filter-accordion__title">{{ config.label }}</span>
        <span class="sr-only">, </span>
        <span class="filter-accordion__icon" :aria-label="collapseAriaLabel">{{ isOpen ? '−' : '+' }}</span>
      </div>

      <div v-show="isOpen">
        <range-inline
          :items="_config.items"
          @select="onSelect"
           :view="config.attrs.view"
           :rangetype="config.name"
        />
      </div>
    </template>

    <!-- ===== EXISTING BEHAVIOR (UNCHANGED) ===== -->
    <template v-else>
  
      <range-inline
        v-if="config.mode === 'inline'"
        :items="_config.items"
        :label="config.label"
        @select="onSelect"
       
      />

      <range-dropdown
        v-else-if="config.mode === 'dropdown'"
        :label="config.label"
        :items="_config.items"
        @select="onSelect"
      />
    </template>

  </div>
</template>

<script>
import featureMixin from "@/mixins/featureMixin";
import RangeDropdown from "@/features/filters/range/RangeDropdown.vue";
import RangeInline from "@/features/filters/range/RangeInline.vue";
import { mapActions,mapGetters } from "vuex";

export default {
  name: "RangeFilter",
  components: { RangeInline, RangeDropdown },
  mixins: [featureMixin],

  data() {
    return {
     //open: false
    };
  },

  computed: {
   ...mapGetters("filters", ["activeAccordionSections"]),
    isAccordion() {
      return this.config?.attrs?.view === "accordion" ? true : false;
    },
    isOpen() {
    return (
      Array.isArray(this.activeAccordionSections) &&
      this.activeAccordionSections.includes(this.config.name)
    );
  },
    collapseAriaLabel() {
      const caption = this.config.label || '';
      const phrase = this.isOpen ? this.content.collapseOptionsAbout : this.content.expandOptionsAbout;
      return `${phrase} ${caption}`;
    }
  },

  methods: {
    ...mapActions("events", ["triggerEvent"]),
    ...mapActions("filters", ["openAccordionSection","closeAccordionSection", "clearRating"]),
    toggle() {
    if (this.isOpen) {
      this.closeAccordionSection(this.config.name);
    } else {
      this.openAccordionSection(this.config.name);
    }
  },

    onSelect(item) {
      if (this.config.name === 'rating') {
        const shouldSelect = item.selected;
        this.clearRating();
        if (shouldSelect) {
          item.selected = true;
        }
      }
      this.openAccordionSection(this.config.name);
      this.triggerEvent({
        event: `filter-toggle-event-${this.config.name}`,
        data: item
      });
    }
  }
};
</script>

<style lang="scss">
/* ===== Accordion styles (CTC only) ===== */

.filter-accordion__header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 12px 16px;
  cursor: pointer;
  background: #fff;
  border-bottom: 1px solid #E5E5E5;
}

.filter-accordion__title {
  font-size: 14px;
  font-weight: 500;
  color: #000;
}

.filter-accordion__icon {
  font-size: 18px;
  line-height: 1;
}

.filter-accordion__body {
  padding: 0px 0px 0px;
}
</style>
